@if (visible) {
  <div class="chart-modal-backdrop" (click)="closeOnBackdrop($event)">
    <div class="chart-modal" role="dialog" [attr.aria-label]="title">
      <div class="chart-modal-header">
        <div class="chart-modal-header-left">
          <h2>{{ title }}</h2>
          <ng-content select="[chart-subtitle]"></ng-content>
        </div>
        <div class="chart-modal-header-right">
          <ng-content select="[chart-controls]"></ng-content>
          <button class="chart-modal-close" (click)="close()" aria-label="Fermer">
            <span class="material-symbols-outlined">close</span>
          </button>
        </div>
      </div>
      <div class="chart-modal-body">
        <app-chart-host-overlay
          class="chart-modal-chart"
          [loading]="loading"
          loadingLabel="Chargement du graphique..."
          ariaLabel="Graphique de production"
          (hostReady)="onChartHostReady($event)"
        />
      </div>
    </div>
  </div>
}
